<template>
	<div
		v-if="objectdata && objectdata.type == 'text'"
		is="app-content-element-text"
		:type="objectdata.type"
		:objectdata="objectdata"
	/>
	<div
		v-else-if="objectdata && objectdata.type == 'Slider'"
		is="app-content-element-slider"
		:type="objectdata.type"
		:objectdata="objectdata"
	/>
	<div
		v-else-if="objectdata && objectdata.type == 'Zitat'"
		is="app-content-element-quote"
		:type="objectdata.type"
		:objectdata="objectdata"
	/>
	<div
		v-else-if="objectdata && objectdata.type == 'headline'"
		is="app-content-element-headline"
		:type="objectdata.type"
		:objectdata="objectdata"
	/>
	<div
		v-else-if="objectdata && objectdata.type == 'Link'"
		is="app-content-element-link"
		:type="objectdata.type"
		:objectdata="objectdata"
	/>
	<div
		v-else-if="objectdata && objectdata.type == 'accordionSingle'"
		is="app-content-element-accordion"
		:type="objectdata.type"
		:objectdata="objectdata"
	/>
	<div
		v-else-if="objectdata && objectdata.type == 'table'"
		is="app-content-element-table"
		:type="objectdata.type"
		:objectdata="objectdata"
	/>
	<div
		v-else-if="objectdata && objectdata.type == 'image'"
		is="app-content-element-image"
		:type="objectdata.type"
		:objectdata="objectdata"
	/>
	<div
		v-else-if="objectdata && objectdata.type == 'html'"
		is="app-content-element-html"
		:type="objectdata.type"
		:objectdata="objectdata"
	/>
	<div
		v-else-if="objectdata && (objectdata.type == 'Tabitem' || objectdata.type == 'Tabs')"
		is="app-content-element-tab"
		:type="objectdata.type"
		:objectdata="objectdata"
	/>
	<div
		v-else-if="objectdata && objectdata.type == 'ContentArchive'"
		is="app-content-element-content-archive"
		:type="objectdata.type"
		:objectdata="objectdata"
	/>
	<div
		v-else-if="objectdata && objectdata.type == 'form' && objectdata.cssID[0] == 'contact'"
		is="app-content-element-contact-form"
		:type="objectdata.type"
		:objectdata="objectdata"
	/>
	<div
		v-else-if="objectdata && objectdata.type == 'form' && objectdata.cssID[0] == 'complaint'"
		is="app-content-element-complaint-form"
		:type="objectdata.type"
		:objectdata="objectdata"
	/>
	<div
		v-else-if="objectdata && objectdata.type == 'player'"
		is="app-content-element-video"
		:type="objectdata.type"
		:objectdata="objectdata"
	/>
	<div
		v-else-if="objectdata && objectdata.type == 'Jahreszeiten-Wrapper - Start'"
		is="app-content-element-season-wrapper"
		:type="objectdata.type"
		:objectdata="objectdata"
	/>
	<div
		v-else-if="(objectdata && (objectdata.type == 'Produkte - Kategorieübersicht')  && (objectdata.published='1'))"
		is="app-content-element-productcategories"
		:type="objectdata.type"
		:objectdata="objectdata"
	/>
	<div
		v-else-if="objectdata && objectdata.type == 'Kampagnen Top Teaser'"
		is="app-content-element-campaign-top-teaser"
		:type="objectdata.type"
		:objectdata="objectdata"
	/>
	<div
		v-else-if="objectdata && objectdata.type == 'Kampagnen Animation Teaser'"
		is="app-content-element-campaign-animation-teaser"
		:type="objectdata.type"
		:objectdata="objectdata"
	/>
	<div
		v-else-if="objectdata && objectdata.type == 'Anker Element'"
		is="app-content-element-anchor-element"
		:type="objectdata.type"
		:objectdata="objectdata"
	/>
	<div
		v-else-if="objectdata && objectdata.type == 'Trenner'"
		is="app-content-element-seperator-line"
		:type="objectdata.type"
		:objectdata="objectdata"
	/>
	<div
		v-else-if="objectdata && objectdata.type == 'iframe'"
		is="app-content-element-iframe"
		:type="objectdata.type"
		:objectdata="objectdata"
	/>
	<div
		v-else-if="objectdata && objectdata.type == 'Gewinncode-Beschreibung'"
		is="app-content-element-campaign-code-description"
		:type="objectdata.type"
		:objectdata="objectdata"
	/>
</template>
<script>
	import Base from "./Base.vue";
	import AppContentElementHeadline from "./AppContentElementHeadline.vue";
	import AppContentElementText from "./AppContentElementText.vue";
	import AppContentElementContactForm from "./AppContentElementContactForm.vue";
	import AppContentElementComplaintForm from "./AppContentElementComplaintForm.vue";
	import AppContentElementSlider from "./AppContentElementSlider.vue";
	import AppContentElementQuote from "./AppContentElementQuote.vue";
	import AppContentElementLink from "./AppContentElementLink.vue";
	import AppContentElementAccordion from "./AppContentElementAccordion.vue";
	import AppContentElementTable from "./AppContentElementTable.vue";
	import AppContentElementImage from "./AppContentElementImage.vue";
	import AppContentElementHtml from "./AppContentElementHtml.vue";
	import AppContentElementTab from "./AppContentElementTab.vue";
	import AppContentElementContentArchive from "./AppContentElementContentArchive.vue";
	import AppContentElementVideo from "./AppContentElementVideo.vue";
	import AppContentElementSeasonWrapper from "./AppContentElementSeasonWrapper.vue";
	import AppContentElementProductcategories from "./AppContentElementProductcategories.vue";
	import AppContentElementCampaignTopTeaser from "./AppContentElementCampaignTopTeaser.vue";
	import AppContentElementCampaignAnimationTeaser from "./AppContentElementCampaignAnimationTeaser.vue";
	import AppContentElementCampaignCodeDescription from "./AppContentElementCampaignCodeDescription.vue";
	import AppContentElementAnchorElement from "./AppContentElementAnchorElement.vue";
	import AppContentElementSeperatorLine from "./AppContentElementSeperatorLine.vue";
	import AppContentElementIframe from "./AppContentElementIframe.vue";

	export default {
		extends: Base,
		components: {
			AppContentElementHeadline,
			AppContentElementText,
			AppContentElementSlider,
			AppContentElementQuote,
			AppContentElementLink,
			AppContentElementAccordion,
			AppContentElementTable,
			AppContentElementImage,
			AppContentElementHtml,
			AppContentElementTab,
			AppContentElementContactForm,
			AppContentElementComplaintForm,
			AppContentElementContentArchive,

			AppContentElementSeasonWrapper,
			AppContentElementProductcategories,
			AppContentElementVideo,

			AppContentElementCampaignTopTeaser,
			AppContentElementCampaignAnimationTeaser,
			AppContentElementCampaignCodeDescription,
			AppContentElementAnchorElement,
			AppContentElementSeperatorLine,
			AppContentElementIframe
		},
		props: {
			type: false,
			objectdata: {}
		},

		data() {
			return {};
		},
		created() {
			// this.init();
		},
		methods: {}
	};
</script>

<style lang="scss">
</style>